import React from 'react';
import { Text } from '@theme-ui/components';
import ReactTooltip from 'react-tooltip';
import { FaInfoCircle } from 'react-icons/fa';

const SERVER_ERROR =
	'Sorry, some error seems to have occurred and we could not complete your request. Please try again.';
const MOBILE_LENGTH = 'Mobile number must be 10 digits long.';
const MOBILE_PATTERN =
	'Mobile number must start with any one of the following digits: (6/7/8/9).';
const MOBILE_REGEX = new RegExp(/^[6789][0-9]{9}$/);

export const validateEmail = (email) => {
	let error = '';
	if (isNaN(email)) {
		if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(email)) {
			error = 'Please enter a valid email id.';
		}
	}
	return error;
};

export const validatePhone = (mobileNumber) => {
	if (mobileNumber.length !== 10) {
		return MOBILE_LENGTH;
	}
	else if (!MOBILE_REGEX.test(mobileNumber)) {
		return MOBILE_PATTERN;
	}
}

const validateCaptcha = (captcha) => {
	if (!captcha) {
		return { captcha: 'reCAPTCHA is required.' };
	}
};

const validateUsername = (username) => {
	const regex = /^(?=[\w.]{3,20}$)(?!.*[_.]{2})[^_.].*[^_.]$/g;
	if (username) {
		return regex.test(username);
	}
	return null;
};

const UsernameErrMsg = ({ bg = '#F17A28', text = 'white', styles }) => {
	const tooltip = `
    <span>
      Username must:
      <ul>
        <li>contain only alphanumeric characters, underscore & dot.</li>
        <li>not start or end with underscore and dot.</li>
        <li>not have underscore and dot next to each other.</li>
        <li>not use underscore or dot consecutively.</li>
        <li>be 3 to 20 characters long.</li>
      </ul>
    </span>`;

	const textStyle = {
		color: bg,
		textAlign: 'left',
		'.__react_component_tooltip': {
			maxWidth: 270,
			fontWeight: 'normal',
			opacity: 1,
			ul: {
				padding: 0,
				pl: 3,
			},
		},
		'.__react_component_tooltip.show': {
			opacity: '1 !important',
		},
		...styles,
	};

	return (
		<Text sx={textStyle}>
			Invalid Username!{' '}
			<span
				data-tip={tooltip}
				data-background-color={bg}
				data-for='usernameTip'
				style={{ textAlign: 'left' }}
			>
				<FaInfoCircle sx={{ color: 'muted2' }} />
			</span>
			<ReactTooltip textColor={text} effect='solid' html={true} id='usernameTip' />
		</Text>
	);
};

export { validateCaptcha, validateUsername, UsernameErrMsg };
